var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNose2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44.8 38.8",
    style: {
      enableBackground: "new 0 0 44.8 38.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.6;fill:url(#SVGID_00000048481718735936928330000016601102313044998812_);enable-background:new    ;}\n\t.st2{opacity:0.6;fill:url(#SVGID_00000127737240483916819620000008473538026260957874_);enable-background:new    ;}\n\t.st3{opacity:0.6;fill:url(#SVGID_00000008848465494070311620000006628830276925237692_);enable-background:new    ;}\n\t.st4{fill:url(#SVGID_00000038387486676783774890000009635845803411355554_);}\n\t.st5{fill:url(#SVGID_00000002371121269297470830000001750315909901270686_);}\n\t.st6{opacity:0.25;fill:url(#SVGID_00000085970091471604037810000000193441496630533293_);enable-background:new    ;}\n\t.st7{opacity:0.6;fill:url(#SVGID_00000076605824762301139470000004487372031792565931_);enable-background:new    ;}\n\t.st8{opacity:0.6;fill:url(#SVGID_00000165199231547778655240000005380132953829656454_);enable-background:new    ;}\n\t.st9{fill:#FFCCB8;}\n\t.st10{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.3996,
    y1: -73.4727,
    x2: 22.3996,
    y2: 230.9371,
    gradientTransform: "matrix(1 0 0 -1 0 39.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2AD97",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9673",
      stopOpacity: 0.6
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.8,14.7C43.2,11.3,30.1,1.1,25,0.1C24.5,0,23.3,0,22.4,0s-2.1,0-2.7,0.1c-5,1-18.2,11.2-18.8,14.6 C0.4,17.8-0.3,24,0.1,24.8c0.6,1.2,8.6,4,14.7,5.8c0,0,1.9,1.7,4.8,2.3C20,33,21.3,33,22.4,33s2.4,0,2.8-0.1 c2.9-0.6,4.8-2.3,4.8-2.3c6.1-1.8,14-4.6,14.7-5.8C45.1,24,44.4,17.8,43.8,14.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005972411703541974860000005642694790753928845_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.525,
    y1: 26.8025,
    x2: 10.5092,
    y2: -2.486,
    gradientTransform: "matrix(1 0 0 -1 0 39.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000005972411703541974860000005642694790753928845_)",
      enableBackground: "new"
    },
    d: " M7.6,22.7c3.7-0.2,6-18,6.1-19.8c-0.5,3.6-1.3,10.7-1.3,12.3c0.1,6.1,1.4,8.8,2.3,9.9C14.1,24.7,11,23.2,7.6,22.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152265590384358087360000010931327052793980311_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.9979,
    y1: 25.9709,
    x2: 32.9824,
    y2: -3.3096,
    gradientTransform: "matrix(1 0 0 -1 0 39.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000152265590384358087360000010931327052793980311_)",
      enableBackground: "new"
    },
    d: " M37.2,22.7C36,21.4,31.8,12.9,31.1,3c0.5,3.6,1.3,10.7,1.3,12.3c-0.1,6.1-1.4,8.8-2.3,9.9C30.6,24.7,33.8,23.2,37.2,22.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003812587320790141000000013107195703622437306_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.4302,
    y1: 16.7976,
    x2: 22.1754,
    y2: 7.4096,
    gradientTransform: "matrix(1 0 0 -1 0 39.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000003812587320790141000000013107195703622437306_)",
      enableBackground: "new"
    },
    d: " M22.3,32.8c-5.8,0-8.4-6.6-7.6-7.6c1-1.3,15.2-0.2,15.3,0C30.9,27.6,27.6,32.8,22.3,32.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170276034065905603180000011758589866447412887_",
    gradientUnits: "userSpaceOnUse",
    x1: -5936.7622,
    y1: 12.1136,
    x2: -5925.479,
    y2: 12.1136,
    gradientTransform: "matrix(-1 0 0 -1 -5894.4111 39.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77254B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170276034065905603180000011758589866447412887_)"
    },
    d: "M42.4,25.7c0.1-0.8-4.4-0.6-7.1,1.2 c-2.7,1.9-4.2,3.4-4.2,3.4S42.2,27,42.4,25.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083060357678792484840000018240874922109336202_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.5833,
    y1: 12.1484,
    x2: 14.8669,
    y2: 12.1484,
    gradientTransform: "matrix(1 0 0 -1 0 39.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77254B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083060357678792484840000018240874922109336202_)"
    },
    d: "M3.6,25.7C3.5,24.8,8,25,10.7,26.9 s4.2,3.4,4.2,3.4S3.7,27,3.6,25.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010288005980377286180000010897218058634761358_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.3354,
    y1: 16.3916,
    x2: 22.3354,
    y2: 39.7568,
    gradientTransform: "matrix(1 0 0 -1 0 39.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777",
      stopOpacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000010288005980377286180000010897218058634761358_)",
      enableBackground: "new"
    },
    d: " M30.5,22.7c0-0.8,2.4-23.1-8.3-22.6c-10.7,0.6-7.9,21.3-8,22.6C14.1,24,30.5,23.5,30.5,22.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064340888499614319920000011996824760162754712_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.3712,
    y1: 43.7008,
    x2: 22.3712,
    y2: 11.595,
    gradientTransform: "matrix(1 0 0 -1 0 39.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000064340888499614319920000011996824760162754712_)",
      enableBackground: "new"
    },
    d: " M44.6,24.8c-0.6,1.2-8.6,4-14.7,5.8c0,0-1.9,1.7-4.8,2.3C24.8,33,23.5,33,22.4,33s-2.4,0-2.8-0.1c-2.9-0.6-4.8-2.3-4.8-2.3 c-6.1-1.8-14-4.6-14.7-5.8c-0.4-0.8,0.2-7,0.8-10.1c0-0.2,0.1-0.5,0.3-0.8c-0.5,2.9-1.2,9.2,3.5,8.7c4.6-0.5,9.9,2.2,10,2.5 c0.3-0.6,4-0.7,7.7-0.6c3.7-0.1,7.4,0,7.7,0.6c0.1-0.3,5.4-3,10-2.5s4-5.7,3.5-8.7c0.1,0.3,0.2,0.5,0.3,0.7 C44.4,17.8,45.1,24,44.6,24.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023264752761953688060000007118862174906888381_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.3682,
    y1: 36.5914,
    x2: 22.3682,
    y2: -3.6582,
    gradientTransform: "matrix(1 0 0 -1 0 39.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000023264752761953688060000007118862174906888381_)",
      enableBackground: "new"
    },
    d: " M44.6,24.8c-0.6,1.2-6,14-22.2,14S0.8,26,0.1,24.8C-0.3,24,0,23.2,4.6,22.7s9.9,2.2,10,2.5c2.7,3,11.1,3.5,15.3,0 c0.1-0.3,5.4-3,10-2.5C44.7,23.2,45.1,24,44.6,24.8z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M14.2,23.9c0,0,2-3.4,5-2.9c2.9,0.5,11,1.5,10.3,1.8C28.8,23.1,15.4,23.8,14.2,23.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M16.6,20.3c-0.6,0.4-2.3,3.6-1.7,3.5c0.5,0,5.8,0,5.8,0L16.6,20.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNose2);
export default __webpack_public_path__ + "static/media/Nose2.8ba9ec5d7aaa089160d8623076a030b5.svg";
export { ForwardRef as ReactComponent };